import { FC, PropsWithChildren } from 'react';

const Truncate: FC<PropsWithChildren<{
  className?: string,
  title?: string,
}>> = ({
  children,
  className,
  title,
}) => (
  <div
    className={`grid w-full overflow-hidden ${className}`}
    {...(title ? { title } : {})}
  >
    <div className="truncate">{children}</div>
  </div>
);

export default Truncate;
